import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MapsLiveIndexRoute extends Route {
  @service store;
  @service router;

  async beforeModel() {
    const { areaMap, currentUserReservationMapFloor } = this.modelFor('spaces.maps');
    const firstMapFloor = (await areaMap.mapFloors).sortBy('ordinality').slice()[0];
    if (currentUserReservationMapFloor?.rasterImageUrl) {
      this.router.transitionTo('spaces.maps.live.show', currentUserReservationMapFloor.id);
    } else if (firstMapFloor) {
      this.router.transitionTo('spaces.maps.live.show', firstMapFloor.id);
    }
  }

  model() {
    const { areaMap } = this.modelFor('spaces.maps');
    return { areaMap };
  }
}
